export function normalizeSpeedTestDomainUrl(domainName: string): string {
    const trimmed = domainName.trim();
    // Preserve explicit schemes so invalid URLs still reach the existing validation unchanged.
    return trimmed && !/^[a-z][a-z0-9+.-]*:\//i.test(trimmed)
        ? `https://${trimmed}`
        : trimmed;
}



// WEBPACK FOOTER //
// ./js/components/templates/speedTestDomainUrl.ts